import { createSlice } from "@reduxjs/toolkit";
import { readThunkError } from "../thunkError";
import {
  getGetterAccounts,
  addGetterAccount,
  updateGetterAccount,
  deleteGetterAccount,
  getGetterTaskStatus,
  runGetterForTask,
  stopGetterForTask,
  getGetterJobs,
} from "./thunk";

export const initialState = {
  accounts: [],
  // Getter идэвхжсэн судалгаанууд (tasks) — төлөв, тоо
  taskStatus: [],
  jobs: [],

  accountsLoading: false,
  taskStatusLoading: false,
  jobsLoading: false,
  error: null,
};

const asArray = (v) => (Array.isArray(v) ? v : []);

const getterSlice = createSlice({
  name: "getter",
  initialState,
  reducers: {
    clearGetterError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    /* Аватарууд */
    builder.addCase(getGetterAccounts.pending, (state) => {
      state.accountsLoading = true;
    });
    builder.addCase(getGetterAccounts.fulfilled, (state, action) => {
      state.accounts = asArray(action.payload);
      state.accountsLoading = false;
    });
    builder.addCase(getGetterAccounts.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.accountsLoading = false;
    });

    builder.addCase(addGetterAccount.fulfilled, (state, action) => {
      if (action.payload) state.accounts.push(action.payload);
    });
    builder.addCase(updateGetterAccount.fulfilled, (state, action) => {
      const updated = action.payload;
      if (!updated) return;
      state.accounts = state.accounts.map((a) =>
        String(a._id) === String(updated._id) ? { ...a, ...updated } : a
      );
    });
    builder.addCase(deleteGetterAccount.fulfilled, (state, action) => {
      state.accounts = state.accounts.filter((a) => String(a._id) !== String(action.payload));
    });

    /* Судалгааны төлөв (tasks) */
    builder.addCase(getGetterTaskStatus.pending, (state) => {
      state.taskStatusLoading = true;
    });
    builder.addCase(getGetterTaskStatus.fulfilled, (state, action) => {
      state.taskStatus = asArray(action.payload);
      state.taskStatusLoading = false;
    });
    builder.addCase(getGetterTaskStatus.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.taskStatusLoading = false;
    });

    builder.addCase(runGetterForTask.fulfilled, (state, action) => {
      const { taskId, pid } = action.payload || {};
      state.taskStatus = state.taskStatus.map((t) =>
        String(t._id) === String(taskId)
          ? { ...t, getter: { ...(t.getter || {}), runPid: pid } }
          : t
      );
    });
    builder.addCase(stopGetterForTask.fulfilled, (state, action) => {
      state.taskStatus = state.taskStatus.map((t) =>
        String(t._id) === String(action.payload)
          ? { ...t, getter: { ...(t.getter || {}), runPid: null } }
          : t
      );
    });

    /* Ажлууд */
    builder.addCase(getGetterJobs.pending, (state) => {
      state.jobsLoading = true;
    });
    builder.addCase(getGetterJobs.fulfilled, (state, action) => {
      state.jobs = asArray(action.payload);
      state.jobsLoading = false;
    });
    builder.addCase(getGetterJobs.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.jobsLoading = false;
    });

    /* Нийтлэлүүд */


    /* Статистик */
  },
});

export const { clearGetterError } = getterSlice.actions;
export default getterSlice.reducer;
